import React from "react";
import Classes from "./RecordTable.module.css";
import MoreDropDown from "./MoreDropDown";

// Displays the row and delegates actions to MoreDropDown
export default function TableRow({ value, rawDoc, bookingId, onChanged }) {
  return (
    <>
      <div className={`${Classes.customerRow}`} key={value._id}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}>
          <h5>{value.Name}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem2}`}>
          <h5>{value.Type}</h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem3}`}>
          <h5> {value.UploadedBy} </h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem4}`}>
          <h5> {value.Uploaded} </h5>
        </div>
        <div className={`${Classes.rowElem} ${Classes.elem5}`}>
          <MoreDropDown
            bookingId={bookingId}
            doc={rawDoc}
            onDeleted={onChanged}
            onDownload={() => window.open(rawDoc.url, "_blank", "noopener")}
          />
        </div>
      </div>

      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}>
            <h4>Name</h4>
            <h5> {value.Name} </h5>
          </div>

          <div className={Classes.mobElem}>
            <h4>Type</h4>
            <h5> {value.Type} </h5>
          </div>
          <div className={Classes.mobElem}>
            <div style={{ marginTop: "5px" }}>
              {/* Keep header Add button as the primary uploader; no button here */}
            </div>
          </div>
        </div>

        <div>
          <div className={Classes.mobElem}>
            <h4>Uploaded By</h4>
            <h5> {value.UploadedBy} </h5>
          </div>
          <div className={Classes.mobElem}>
            <h4>Uploaded</h4>
            <h5> {value.Uploaded} </h5>
          </div>
        </div>
        <MoreDropDown
          bookingId={bookingId}
          doc={rawDoc}
          onDeleted={onChanged}
          onDownload={() => window.open(rawDoc.url, "_blank", "noopener")}
        />
      </div>
    </>
  );
}
